import { fullyVisibleIndices } from '@tilelist/domain/black-friday-slider/fullyVisibleIndices.ts';
import type { Bounds } from '@tilelist/domain/black-friday-slider/fullyVisibleIndices.ts';
import type { ProductItem } from '@tilelist/domain/composition/TileListitem.ts';

export function allTileIndices(items: ProductItem[]): number[] {
    return items.map((_, index) => index);
}

/*                                                                                                      */
export function visibleTiles(
    root: HTMLElement | null,
    items: ProductItem[],
    indices: number[],
): ProductItem[] | undefined {
    const cinema = root?.querySelector('oc-cinema-v1');
    if (!cinema) return tilesAt(items, indices);

    const stage = cinema.getBoundingClientRect();
    const tiles = new Map<number, Bounds>();
    /*                                                                */
    for (const index of stage.width === 0 ? indices : allTileIndices(items)) {
        const tile = cinema.children[index];
        if (tile instanceof HTMLElement) tiles.set(index, tile.getBoundingClientRect());
    }

    const visibleIndices = fullyVisibleIndices(stage, tiles);
    return visibleIndices && tilesAt(items, visibleIndices);
}

function tilesAt(items: ProductItem[], indices: number[]): ProductItem[] {
    return indices.map((index) => items[index]).filter((item): item is ProductItem => !!item);
}
